import script from "./TaxRelocate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxRelocate.vue?vue&type=script&setup=true&lang=ts"

import "./TaxRelocate.vue?vue&type=style&index=0&id=5c623362&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c623362"]])

export default __exports__